import { formatISO, parseISO } from 'date-fns';
import ClientDto from './client-dto';

export default class Client
{
    public dto!: ClientDto;

    public constructor(dto: ClientDto)
    {
        this.dto = Object.assign({}, dto);
    }

    public get id(): number|null
    {
        return this.dto.id;
    }

    public set id(id: number|null)
    {
        this.dto.id = id;
    }

    public get name(): string
    {
        return this.dto.name;
    }

    public set name(name: string)
    {
        this.dto.name = name;
    }

    public get comments(): string|null
    {
        return this.dto.comments;
    }

    public set comments(comments: string|null)
    {
        this.dto.comments = comments;
    }

    public get url(): string|null
    {
        return this.dto.url;
    }

    public set url(url: string|null)
    {
        this.dto.url = url;
    }

    public get email(): string|null
    {
        return this.dto.email;
    }

    public set email(email: string|null)
    {
        this.dto.email = email;
    }

    public get addressLine1(): string|null
    {
        return this.dto.addressLine1;
    }

    public set addressLine1(addressLine1: string|null)
    {
        this.dto.addressLine1 = addressLine1;
    }

    public get addressLine2(): string|null
    {
        return this.dto.addressLine2;
    }

    public set addressLine2(addressLine2: string|null)
    {
        this.dto.addressLine2 = addressLine2;
    }

    public get addressTown(): string|null
    {
        return this.dto.addressTown;
    }

    public set addressTown(addressTown: string|null)
    {
        this.dto.addressTown = addressTown;
    }

    public get addressCounty(): string|null
    {
        return this.dto.addressCounty;
    }

    public set addressCounty(addressCounty: string|null)
    {
        this.dto.addressCounty = addressCounty;
    }

    public get addressPostcode(): string|null
    {
        return this.dto.addressPostcode;
    }

    public set addressPostcode(addressPostcode: string|null)
    {
        this.dto.addressPostcode = addressPostcode;
    }

    public get archived(): boolean
    {
        return this.dto.archived;
    }

    public set archived(archived: boolean)
    {
        this.dto.archived = archived;
    }

    public get disabled(): boolean
    {
        return this.dto.disabled;
    }

    public set disabled(disabled: boolean)
    {
        this.dto.disabled = disabled;
    }

    public get dateCreated(): Date
    {
        return parseISO(this.dto.dateCreated);
    }

    public set dateCreated(dateCreated: Date)
    {
        this.dto.dateCreated = formatISO(dateCreated);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public get params(): {[key: string]: any}
    {
        return this.dto;
    }
}